module.exports = __webpack_public_path__ + "media/icons/bill-0c585135.png";